
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.725 1.236a.586.586 0 011.172 0v.3h3.59v-.3a.586.586 0 111.172 0v.302h.975a1.8 1.8 0 011.8 1.8v8.279a1.8 1.8 0 01-1.8 1.799H2.75a1.8 1.8 0 01-1.799-1.8V3.336a1.8 1.8 0 011.8-1.8h.975v-.299zM2.75 2.711a.628.628 0 00-.627.627V3.8h9.138v-.462a.63.63 0 00-.627-.628h-.978v.3a.586.586 0 01-1.173 0v-.3H4.897v.3a.586.586 0 11-1.172 0v-.3H2.75zm-.627 2.262h9.138v6.646a.63.63 0 01-.628.627H2.75a.63.63 0 01-.627-.627V4.973zM3.47 7.018c0-.405.328-.733.732-.733h.16a.732.732 0 110 1.465h-.16a.732.732 0 01-.732-.732zm2.287 0c0-.405.328-.733.733-.733h.16a.732.732 0 110 1.465h-.16a.732.732 0 01-.733-.732zm2.288 0c0-.405.328-.733.732-.733h.16a.732.732 0 110 1.465h-.16a.732.732 0 01-.732-.732zm-2.288 2.5c0-.405.328-.733.733-.733h.16a.732.732 0 110 1.465h-.16a.732.732 0 01-.733-.732zm2.288 0c0-.405.328-.733.732-.733h.16a.732.732 0 110 1.465h-.16a.732.732 0 01-.732-.732zm-4.575 0c0-.405.328-.733.732-.733h.16a.732.732 0 110 1.465h-.16a.732.732 0 01-.732-.732z","fill":"#9DA7B2"}})])
          )
        }
      }
    